const getDonationMessageInitialValues = (hasDonationMessageField) =>
    hasDonationMessageField
        ? {
              Donation_Message: "",
              Has_Donation_Message: false,
          }
        : {};

export default getDonationMessageInitialValues;
